import { z } from "zod";

/** Uploaded media belong to one tenant: "<tenantId>/<id>.webp". */
export const mediaKeySchema = z
  .string()
  .regex(/^[0-9a-z-]{8,64}\/[0-9a-z-]{8,64}\.(webp|jpg|png)$/, "Unknown image");

export function mediaBelongsTo(key: string, tenantId: string): boolean {
  return key.startsWith(`${tenantId}/`);
}
